package team.platforma.multiplatform_material_extension.ui.core.field_utils

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.Icon
import androidx.compose.material3.LocalContentColor
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import team.platforma.multiplatform_material_extension.ui.core.InputFieldState

@Composable
internal fun endIcon(
    drawableResource: DrawableResource,
    inputFieldState: InputFieldState,
    rotate: Boolean? = null,
    loading: Boolean? = null,
    tint: Color? = null
) {

    val rotationAngle by animateFloatAsState(
        targetValue = rotate?.let { if (it) 180f else 0f } ?: 0f,
        animationSpec = tween(durationMillis = 250)
    )

    Box(
        modifier = Modifier.size(40.dp)
            .clip(CircleShape)
            .clickable {
                inputFieldState.endIconClick()
            }
        ,
        contentAlignment = Alignment.Center
    ) {
        Icon(
            painter = painterResource(drawableResource),
            contentDescription = null,
            modifier = Modifier.size(20.dp)
                .graphicsLayer {
                    rotationZ = rotationAngle
                },
            tint = tint ?: LocalContentColor.current
        )

        loading?.let { boolean ->
            if (boolean) {
                CircularProgressIndicator(
                    modifier = Modifier.size(40.dp),
                )
            }

        }
    }

}